export const SAMPLE_ADS = [
  {
    category: "Matrimonial",
    ads: [
      {
        title: "BRIDE WANTED",
        content: "SM4, 28/5'10\", MBA, working in MNC Bangalore, 18LPA. Seeks fair, educated, prof. qualified girl from decent family. Caste no bar. Send BHP/Photo to matrimonial@email.com"
      },
      {
        title: "GROOM WANTED",
        content: "Alliance invited for Iyer girl, 26/5'4\", BE (CS), working in Chennai. Seeks well-settled boy, BE/ME/MBA, working in India/Abroad. Ph: 9876543210"
      }
    ]
  },
  {
    category: "Property Sale",
    ads: [
      {
        title: "FLAT FOR SALE",
        content: "2BHK, 1100 sqft, East facing, semi-furnished, Indiranagar, Bangalore. Clear title, OC/CC available. Price 85L. Contact Owner: 9988776655"
      },
      {
        title: "PLOT FOR SALE",
        content: "1200 sqft residential plot for sale in Whitefield, gated community, all amenities. BDA approved. Brokers excuse. Call: 8877665544"
      }
    ]
  },
  {
    category: "Property Rent",
    ads: [
      {
        title: "TO LET",
        content: "3BHK luxury apartment for rent in Koramangala. Fully furnished, 24hr water/power. Rent 45k + Maint. Family/Bachelors. Ph: 7766554433"
      },
      {
        title: "OFFICE SPACE",
        content: "1500 sqft commercial space available for rent in MG Road. Suitable for IT/Consultancy. Ample parking. Contact: 6655443322"
      }
    ]
  },
  {
    category: "Recruitment",
    ads: [
      {
        title: "SITUATION VACANT",
        content: "Wanted Accounts Manager for a leading Mfg co. in Peenya. B.Com/M.Com with 5+ yrs exp in Tally/GST. Salary best in industry. Email resume: hr@company.com"
      },
      {
        title: "WALK-IN INTERVIEW",
        content: "Urgent opening for Telecallers (F). Fluency in Eng/Kan/Hin. Day shift. Sal 15k-20k + Incentives. Walk-in: 10am-5pm, #123, Jayanagar 4th Block."
      }
    ]
  },
  {
    category: "Public Notice",
    ads: [
      {
        title: "PUBLIC NOTICE",
        content: "Notice is hereby given that my client Mr. Sharma has agreed to purchase property bearing No. 45, HSR Layout from Mr. Rao. Any claims regarding this property should be made within 7 days."
      }
    ]
  },
  {
    category: "Name Change",
    ads: [
      {
        title: "CHANGE OF NAME",
        content: "I, Suresh Kumar S/o Ramesh, R/o Bangalore, have changed my name to Suresh Kumar Sharma for all future purposes vide affidavit dated 29-12-2025 before Notary Public."
      }
    ]
  },
  {
    category: "Lost & Found",
    ads: [
      {
        title: "LOST",
        content: "Lost original degree certificate of VTU, bearing Reg No. 1AB15CS001. If found, please return to Ravi, #12, 1st Main, Rajajinagar. Reward promised. Ph: 9900990099"
      }
    ]
  },
  {
    category: "Business",
    ads: [
      {
        title: "BUSINESS PROPOSAL",
        content: "Running Restaurant for sale in prime location of Indiranagar. Fully equipped kitchen, 50 seater. High footfall. Moving abroad. Genuine buyers contact: 9876543210"
      }
    ]
  },
  {
    category: "Vehicle Sale",
    ads: [
      {
        title: "CAR FOR SALE",
        content: "Honda City ZX CVT (2022), Petrol, White, Single Owner, 15000 kms done. Showroom condition. Insurance valid. Price 12.5L (Nego). Ph: 8899001122"
      }
    ]
  },
  {
    category: "Obituary",
    ads: [
      {
        title: "SAD DEMISE",
        content: "With profound grief, we inform the passing away of Smt. Lakshmi Devi (85) on 28-12-2025. Cremation at Wilson Garden Crematorium at 11 AM today. In grief: Family & Friends."
      }
    ]
  },
  {
    category: "Remembrance",
    ads: [
      {
        title: "REMEMBRANCE",
        content: "1st Death Anniversary of Mr. K.R. Rao. Your memories are our keepsake, with which we will never part. God has you in his keeping, we have you in our hearts. Inserted by: Rao Family."
      }
    ]
  },
  {
    category: "Services",
    ads: [
      {
        title: "PACKERS & MOVERS",
        content: "Safe & Reliable shifting of household goods, car/bike transport. All India Service. Door to Door. Insurance available. Call: 9988776655"
      }
    ]
  },
  {
    category: "Travel",
    ads: [
      {
        title: "TOURS & TRAVELS",
        content: "Tirupati Package (Sheegra Darshan) by AC Volvo/Car. Daily trips. Also booking for Shirdi, Mysore, Ooty packages. Best rates. Contact: 9845012345"
      }
    ]
  },
  {
    category: "Announcement",
    ads: [
      {
        title: "RETAIL OPENING",
        content: "Grand Opening of 'Silk Saree Palace' on 1st Jan 2026 at Malleswaram. Inauguration by Cine Star. Flat 20% off on opening day. All are welcome."
      }
    ]
  }
];
